/**
 * Modification d'une campagne — portail admin. Le formulaire est partagé
 * (`CampagneEditForm`, @repo/campagne) ; seule la query d'alimentation est
 * cross-org (`obtenirCampagneSuperAdmin`).
 *
 * L'autorisation reste serveur : `campagnes.modifierCampagne` laisse passer
 * tout super-admin.
 */
import { CampagneEditForm } from "@repo/campagne";
import { Breadcrumb, PageContainer } from "@repo/ui";
import { useQuery } from "convex/react";
import { useParams } from "react-router";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";
import { arianeOrganisation } from "../../lib/ariane";

export function CampagneModifierAdmin() {
  const { id } = useParams<{ id: string }>();
  const campagneId = id as Id<"campagnes">;

  const campagne = useQuery(api.campagnes.obtenirCampagneSuperAdmin, {
    campagneId,
  });

  const detailHref = `/campagnes/${campagneId}`;

  return (
    <PageContainer>
      <Breadcrumb
        items={[
          ...arianeOrganisation(campagne?.organisationId, campagne?.organisationNom, "campagnes"),
          { label: campagne?.nom ?? "Campagne", href: detailHref },
          { label: "Modifier" },
        ]}
      />

      <div className="mt-6">
        {campagne === undefined && (
          <p className="text-sm text-muted-foreground">Chargement…</p>
        )}
        {campagne === null && (
          <p className="text-sm text-muted-foreground">Campagne introuvable.</p>
        )}
        {campagne && (
          <CampagneEditForm
            campagne={campagne}
            retourHref={detailHref}
            retourLabel="Retour à la campagne"
            afficherOrganisationFigee
          />
        )}
      </div>
    </PageContainer>
  );
}
